import React, { useCallback, useMemo, useState } from "react"
import { SelecionarFormaPagamentoProps } from "./selecionar-forma-pagamento-props"
import { Box, Fade, Typography } from "@material-ui/core"
import { useStyles } from "./selecionar-forma-pagamento-styles"
import { FasesHeader } from "../../../components/fases-header/fases-header"
import { PagamentoIcon } from "components/icons/pagamento-icon"
import { SelecionarFormaPagamentoList } from "./selecionar-forma-pagamento-list/selecionar-forma-pagamento-list"
import { InformarPagamentoDinheiro } from "./informar-pagamento-dinheiro/informar-pagamento-dinheiro"
import { FinalizadoraModel } from "api/cardapio/models/finalizadora/finalizadora-model"
import { usePedidos } from "services/providers/pedidos-provider"
import { EnumPagTpMod } from "models/enums/enum-pag-tpmod"

export const SelecionarFormaPagamento = ({
    onClickVoltar,
    onClickFaseConfirmacao
}: SelecionarFormaPagamentoProps) => {
    const classes = useStyles()
    const { tipoPagamento, selecionarTransacao, getItensSacola, setFinalizadoraSelecionada, finalizadoraSelecionada } = usePedidos()
    const [mostrarDinheiro, setMostrarDinheiro] = useState(false)

    const textosTpPagamento = {
        titulo: tipoPagamento === 'entrega' ? 'Pagar na entrega' : 'Pagar Agora',
        descricao: tipoPagamento === 'entrega' ? 'Escolha a forma de pagamento para a entrega' : 'Escolha como você quer pagar no momento.'
    }

    const confirmarValor = (valor: number) => {
        if (finalizadoraSelecionada) {
            selecionarTransacao({ finalizadora: finalizadoraSelecionada, valor, pagamentoAReceber: true })
            onClickFaseConfirmacao()
        }
    }

    const valorPedido = useMemo(() => {
        const itensSacola = getItensSacola()
        return itensSacola.reduce((acumulado, item) => acumulado + item.vFinal, 0)
    }, [getItensSacola])

    const selecionarFormaPagamento = useCallback((finalizadora: FinalizadoraModel) => {
        selecionarTransacao({
            finalizadora: finalizadora,
            valor: valorPedido,
            pagamentoAReceber: tipoPagamento === 'entrega' ? true : false
        })
        setFinalizadoraSelecionada(finalizadora)
        if (finalizadora.tpMod !== EnumPagTpMod.DINHEIRO) {
            onClickFaseConfirmacao()
        }
    }, [onClickFaseConfirmacao, selecionarTransacao, setFinalizadoraSelecionada, tipoPagamento, valorPedido])

    const selecionarFormaPagamentoContent = useMemo(() => {
        return (
            <Box className={classes.content}>
                <Box display="flex" flexDirection="column" alignItems="center">
                    <Box>
                        <PagamentoIcon tipo="GERAL" class={classes.iconPrincipal} />
                    </Box>
                    <Typography variant="h5" className={classes.titulo}>
                        {textosTpPagamento.titulo}
                    </Typography>
                    <Typography variant="body2" className={classes.descricao}>
                        {textosTpPagamento.descricao}
                    </Typography>
                </Box>
                <Box mt={4}>
                    <SelecionarFormaPagamentoList
                        tpPagamento={tipoPagamento}
                        setMostrarDinheiro={setMostrarDinheiro}
                        setFinalizadoraSelecionada={finalizadora => {
                            if (finalizadora)
                                selecionarFormaPagamento(finalizadora as FinalizadoraModel)
                        }}
                    />
                </Box>
            </Box>
        )
    }, [classes.content, classes.descricao, classes.iconPrincipal, classes.titulo, selecionarFormaPagamento, textosTpPagamento.descricao, textosTpPagamento.titulo, tipoPagamento])

    return (
        <Fade in>
            <Box height={"100%"} width={"100%"} className={classes.boxContainer}>
                <FasesHeader titulo={"Selecionar Pagamento"} voltar={onClickVoltar} />
                {mostrarDinheiro ? (
                    <InformarPagamentoDinheiro onSubmit={confirmarValor} valorPedido={valorPedido} />
                ) :
                    selecionarFormaPagamentoContent
                }
            </Box>
        </Fade>
    )
}